import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

const isLoggedIn = (): boolean =>
  !!(localStorage.getItem('contacto') || localStorage.getItem('cliente'));

export const guestGuard: CanActivateFn = () => {
  if (!isLoggedIn()) return true;
  return inject(Router).createUrlTree(['/portal/dashboard']);
};
